import { CREST_KEY } from '@/constants/keys';

export const isCrestLogoType = (loaderLogoType: string): boolean =>
  loaderLogoType === CREST_KEY;
